import React from 'react';

const CustomLegendCantFind = ({ customizationModels, templateText }) => {
  return (
    <div>
      <div className="row cantFindRow">
        <div className="col-sm-8 col-xs-12 vertical-align cantFind">
          Can't find what you're looking for? We can customize a sign for you.
          <div className="row visible-xs">
            <img
              className="col-xs-6"
              src={`${cdnBase}/images/legendSearch-cantFindNon.png`}
              alt="Non-Reflective"
            />
            <img
              className="col-xs-6"
              src={`${cdnBase}/images/legendSearch-cantFindRef.png`}
              alt="Reflective"
            />
          </div>

          {customizationModels.map((model) => (
            <a
              key={model.CustomProductId}
              className="btn btn-primary btn-lg"
              href={`/Product/Customization?ProductOptionID=${model.CustomProductId}${templateText}`}
              target="_blank"
              rel="noopener noreferrer" // Added for better security
            >
              Customize {model.Size} {model.Reflectivity}
            </a>
          ))}
        </div>
        <div className="col-sm-4 col-xs-12 cantFind just-a-little-more-space hidden-xs">
          <img
            src={`${cdnBase}/images/legendSearch-cantFindNon.png`}
            alt="Non-Reflective"
          />
        </div>
      </div>
    </div>
  );
};

export default CustomLegendCantFind;
